<template>
  <section>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview />
    </div>
    <!-- start of navbar design -->
    <Navbar />
    <!-- end of navbar design -->
    <div>
      <div id="backBoxProfile">
        <div class="flexBigRight">
          <div
            id="middleColumn"
            :class="{ isWindow: isWindows }"
            style="margin-left: 5px;"
          >
            <div class="profileInfo">
              <button
                v-if="checkFriends"
                @click="toggleSettings"
                class="friendSettingsButton"
                :class="showSettings ? 'shown' : ''"
              ></button>
              <div v-if="showSettings" class="friendSettingContainer">
                <button
                  v-if="!checkFriends() && !checkPending()"
                  @click="removeFriend"
                  class="removeFriendButton"
                >
                  Remove Friend
                </button>
                <button @click="block" class="removeFriendButton">Block</button>
              </div>

              <div id="profileHeader">
                <div
                  class="profileImage"
                  @click="showProfileImage"
                  style="cursor:pointer"
                >
                  <img
                    class="profilePicItself"
                    :src="this.profile.profileImage"
                    alt="profile Image"
                  />
                </div>
                <div id="headerInformation">
                  <div
                    style="display: flex; justify-content: flex-start; align-items: center"
                  >
                    <p v-if="this.profile" class="nameDesign">
                      {{ this.profile.firstName }} {{ this.profile.lastName }}
                    </p>
                  </div>
                  <div id="userMajor">
                    <div style="display: flex; align-items: center">
                      {{ this.year }} - {{ this.major }}
                    </div>
                  </div>
                  <div style="display: flex; align-items: center">
                    <p v-if="this.profile.bio">{{ this.bio }}</p>
                    <p v-else>No bio</p>
                  </div>
                </div>
              </div>
              <div id="additionalInfo">
                <div id="interestList">
                  <div class="topPadding" v-if="interests.length == 0">
                    No Interests
                  </div>
                  <div v-for="(interest, index) in interests" :key="index">
                    <Interest
                      :icon="interest.unicode"
                      :interest="interest.name"
                    />
                  </div>
                </div>
                <!-- INTERESTS -->
              </div>
              <div
                class="photoPamphlet"
                :class="
                  this.profile.images && this.profile.images.length < 4
                    ? 'pamphletLeftAlign'
                    : 'pamphletCenterAlign'
                "
              >
                <div
                  class="photoBox noGrab"
                  v-for="(image, index) in profile.images"
                  @click="showPhoto(index)"
                  :key="index"
                >
                  <img class="profilePhoto" :src="image" />
                </div>
              </div>
              <button
                v-if="checkFriends() && !checkPending()"
                class="addFriendButton"
                @click.prevent="addFriend()"
              >
                Send Link Request
              </button>
              <button
                v-if="checkPending()"
                class="addFriendButton"
                @click.prevent="unsendRequest()"
              >
                Cancel Link Request
              </button>
            </div>

            <div class="singleList" v-if="courseInfo.length != 0">
              <div class="profileTitles">Courses</div>
              <div
                class="viewBox"
                :class="{ centeredBox: courseInfo.length > 4 }"
              >
                <div
                  class="groupText"
                  v-for="(course, index) in courseInfo"
                  :key="index"
                  @click="searchCourse(course.doc, course.id, course.type)"
                >
                  <div class="eachCourse">
                    <img :src="course.profileImage" alt="" class="courseImg" />
                    <p class="courseNames">{{ course.name }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="singleList" v-if="groupInfo.length != 0">
              <div class="profileTitles">Groups</div>
              <div
                class="viewBox"
                :class="{ centeredBox: groupInfo.length > 4 }"
              >
                <div
                  class="groupText"
                  v-for="(group, index) in groupInfo"
                  :key="index"
                  @click="searchCourse(group.doc, group.id, group.type)"
                >
                  <div class="eachCourse">
                    <img :src="group.profileImage" alt="" class="courseImg" />
                    <p class="courseNames">{{ group.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LightBox ref="lightbox" :media="media" :show-light-box="false" />
        </div>
        <div class="profileFriendList">
          <div class="friendListBox" :class="{ isWindow: isWindows }">
            <div class="profileTitles">Friends</div>
            <div
              v-if="friendInfo.length == 0"
              style="margin:auto; padding: 20px"
            >
              No friends yet
            </div>
            <div
              class="viewBox"
              :class="{ centeredBoxBig: friendInfo.length > 2 }"
            >
              <div
                class="profileText"
                v-for="(friend, index) in friendInfo"
                :key="index"
                @click="searchFriend(friend.name, friend.id)"
              >
                <div class="eachCourse">
                  <div class="eachCourseRight">
                    <img :src="friend.profileImage" alt="" class="friendImg" />
                    <div>
                      <p class="courseNames">
                        {{ friend.name }}
                      </p>
                      <p v-if="user.id != friend.id" class="mutualList">
                        {{ friend.mutuals }} mutuals
                      </p>
                      <p v-else class="mutualList">Me</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import { mapState, mapActions } from "vuex";
import db from "@/db";
import firebase from "@/firebase";
import LightBox from "vue-image-lightbox";
import Interest from "@/components/profile/Interest";
import Navbar from "@/components/Navbar";
import GroupPreview from "@/components/group/GroupPreview.vue";

//import router from "@/router/index";

export default {
  props: ["userName"],

  components: {
    LightBox,
    Interest,
    Navbar,
    GroupPreview,
  },
  data: () => ({
    profile: [],
    images: [],
    email: null,
    isWindows: false,
    school: null,
    showSettings: false,
    firstName: "",
    lastName: "",
    clips: 0,
    clippedPostIds: [],
    isShowingClippedPosts: false,
    all: [],
    userID: null,
    linkRequests: [],
    courses: [],
    year: "Year",
    major: "Major",
    bio: "No bio",
    interests: [],
    courseInfo: [],
    groupInfo: [],
    friendInfo: [],
    media: [],
  }),

  created() {
    this.fetchID();
  },

  mounted() {
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    this.isWindows = this.checkOS();
  },
  unmounted() {
    this.detachListeners();
  },
  watch: {
    userName() {
      this.resetData();
      this.fetchID();
    },
  },
  computed: {
    ...mapState("profile", ["isEditingInterest"]),
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", [
      "replies",
      "groupId",
      "groupName",
      "newNotification",
      "searchingGroup",
    ]),
    ...mapState("groupInfo", ["defaultGroupImage"]),
  },
  methods: {
    ...mapActions("user", ["logout", "updateUserGroups"]),
    ...mapActions("messageBoard", [
      "createDirectMessage",
      "addPosts",
      "deletePost",
      "initReplies",
      "newestNotification",
      "unbindPosts",
      "detachListeners",
      "toggleClip",
      "unsubscribeFromTopic",
      "subscribeToTopic",
    ]),
    showProfileImage() {
      this.media = [];
      const fi = {
        thumb: this.profile.profileImage,
        src: this.profile.profileImage,
      };
      this.media.push(fi);
      this.$refs.lightbox.showImage(0);
    },
    showPhoto(index) {
      this.media = [];
      this.profile.images.forEach((image) => {
        const fi = {
          thumb: image,
          src: image,
        };
        this.media.push(fi);
      });
      console.log(this.media);
      this.$refs.lightbox.showImage(index);
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
      }
    },
    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    searchCourse(course, id, type) {
      course.id = id;
      course.type = type;
      this.$store.commit("messageBoard/setSearchGroup", true);
      console.log(course);
      this.$store.commit("messageBoard/setGroupPreview", course);
    },
    searchFriend(name, id) {
      if (id === this.user.id) {
        this.$router.replace({
          name: "Profile",
        });
      } else {
        var userName = name.replace(" ", "-");
        this.$router.replace({
          name: "PublicProfile",
          params: { userName: userName },
        });
      }
      this.$router.go();
    },
    addFriend() {
      let info = {
        id: this.user.id,
        created_at: Date.now(),
      };
      db.collection("users")
        .doc(this.userID)
        .update({
          linkRequests: firebase.firestore.FieldValue.arrayUnion(info),
        });
      this.profile.linkRequests = this.profile.linkRequests
        ? this.profile.linkRequests
        : [];
      this.profile.linkRequests.push(info);
      if (this.profile.iOSToken) {
        var sendLink = firebase
          .functions()
          .httpsCallable("sendLinkRequestNotification");
        sendLink({
          token: this.profile.iOSToken,
          name: this.user.firstName + " " + this.user.lastName,
        });
      }
    },
    toggleSettings() {
      this.showSettings = !this.showSettings;
    },
    removeFriend() {
      const index1 = this.profile.links.indexOf(this.userID);
      this.profile.links.splice(index1, 1);
      const index2 = this.user.links.indexOf(this.userID);
      this.user.links.splice(index2, 1);
      var dmString;
      if (this.user.id > this.userID) {
        dmString = this.user.id + this.userID;
      } else {
        dmString = this.userID + this.user.id;
      }
      let dmIndex = this.user.directMessages.findIndex(
        (x) => x.id === dmString
      );
      this.user.directMessages.splice(dmIndex, 1);
      this.$store.commit("user/setUser", this.user);
      let dmIndex2 = this.profile.directMessages.findIndex(
        (x) => x.id === dmString
      );
      this.profile.directMessages.splice(dmIndex2, 1);
      db.collection("users")
        .doc(this.user.id)
        .update({
          links: firebase.firestore.FieldValue.arrayRemove(this.userID),
          directMessages: this.user.directMessages,
        });
      db.collection("users")
        .doc(this.userID)
        .update({
          links: firebase.firestore.FieldValue.arrayRemove(this.user.id),
          directMessages: this.profile.directMessages,
        });
    },
    block() {
      db.collection("users")
        .doc(this.user.id)
        .update({
          blockedUsers: firebase.firestore.FieldValue.arrayUnion(this.userID),
        });
      const index = this.profile.links.indexOf(this.userID);
      this.profile.links.splice(index, 1);
    },
    unsendRequest() {
      const index = this.profile.linkRequests.findIndex(
        (x) => x.id === this.user.id
      );
      this.profile.linkRequests.splice(index, 1);
      db.collection("users")
        .doc(this.userID)
        .update({
          linkRequests: this.profile.linkRequests,
        });
    },
    fetchID() {
      const nameArray = this.userName.split("-");
      if (nameArray[2]) {
        db.collection("users")
          .where("firstName", "==", nameArray[0])
          .where("lastName", "==", nameArray[1])
          .where("nameCount", "==", Number(nameArray[2]))
          .get()
          .then((doc) => {
            this.initProfile(doc.docs[0].id);
          });
      } else {
        db.collection("users")
          .where("firstName", "==", nameArray[0])
          .where("lastName", "==", nameArray[1])
          .get()
          .then((doc) => {
            this.initProfile(doc.docs[0].id);
          });
      }
    },
    initProfile(id) {
      db.collection("users")
        .doc(id)
        .get()
        .then((doc) => {
          this.profile = doc.data();
          this.profile.images = this.profile.images ? this.profile.images : [];
          this.userID = id;
          this.firstName = doc.data().firstName;
          this.lastName = doc.data().lastName;
          this.clips = doc.data().totalClips;
          this.clippedPostIds = doc.data().clips;
          if (doc.data().year) {
            this.year = doc.data().year;
            this.major = doc.data().major;
          }
          if (doc.data().bio) {
            this.bio = doc.data().bio;
          }
          this.interests = doc.data().interests ? doc.data().interests : [];
          db.collection("schools")
            .doc(doc.data().school_id)
            .get()
            .then((doc) => {
              this.school = doc.data().name;
            });

          for (const index in doc.data().courses) {
            db.collection("courses")
              .doc(doc.data().courses[index].id)
              .get()
              .then((doc) => {
                if (doc.data().school_id === this.user.school_id) {
                  this.courseInfo.push({
                    profileImage: doc.data().profileImage
                      ? doc.data().profileImage
                      : this.defaultGroupImage,
                    name: doc.data().name,
                    id: doc.id,
                    type: "courses",
                    doc: doc.data(),
                  });
                }
              });
          }
          for (const index in doc.data().groups) {
            db.collection("groups")
              .doc(doc.data().groups[index].id)
              .get()
              .then((doc) => {
                if (doc.data().privacyType != "secret") {
                  this.groupInfo.push({
                    profileImage: doc.data().profileImage
                      ? doc.data().profileImage
                      : this.defaultGroupImage,
                    name: doc.data().name,
                    id: doc.id,
                    type: "groups",
                    doc: doc.data(),
                  });
                }
              });
          }
          for (const index in doc.data().links) {
            db.collection("users")
              .doc(doc.data().links[index])
              .get()
              .then((doc) => {
                const filteredArray = doc
                  .data()
                  .links.filter((value) => this.user.links.includes(value));
                this.friendInfo.push({
                  profileImage: doc.data().profileImage,
                  name: doc.data().firstName + " " + doc.data().lastName,
                  mutuals: filteredArray.length,
                  id: doc.id,
                });
              });
          }
        });
      this.email = firebase.auth().currentUser.email;
    },
    checkPending() {
      if (this.profile.linkRequests) {
        return (
          this.profile.linkRequests.findIndex((x) => x.id === this.user.id) !==
          -1
        );
      }
      return false;
    },
    checkFriends() {
      if (this.profile.links) {
        return !this.profile.links.includes(this.user.id);
      }
      return true;
    },
    checkBlocked() {
      if (this.profile.blockedUsers) {
        return this.profile.blockedUsers.includes(this.user.id);
      }
      return false;
    },
    resetData() {
      this.profile = [];
      this.images = [];
      this.email = null;
      this.school = null;
      this.friendInfo = [];
      this.courseInfo = [];
      this.groupInfo = [];
      (this.firstName = ""), (this.lastName = "");
      this.clips = 0;
      this.courses = [];
      this.year = "Select Year and Major";
      this.major = "";
      this.bio = "";
      this.showSettings = false;
      this.interests = [];
    },
  },
};
</script>

<style src="@/styles/views/Profile.css"></style>
